import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { StringKeyOf } from '../types';
import { ApEventMap } from './generic-event-manager.service';

export const GenericEventSinkToken = new InjectionToken<GenericEventSink>('GenericEventSink');

export interface GenericEventSink {
  fireEvent<TData>(
    eventName: string,
    data: TData,
  ): void;

  on<TData = never>(
    eventName: string,
  ): Observable<TData>;

  once<TData = never>(
    eventName: string,
  ): Observable<TData>;
}


// implement this interface instead, if the class can handle ApEventMaps
// these 2 interfaces don't completely fit together, even though they can handle the same events
export interface GenericEventSink2<TEventMap extends ApEventMap = never> {
  fireEvent<TEventName extends StringKeyOf<TEventMap> = never>(
    eventName: TEventName,
    data: TEventMap[TEventName],
  ): void;

  on<TEventName extends StringKeyOf<TEventMap> = never>(
    eventName: TEventName,
  ): Observable<TEventMap[TEventName]>;

  once<TEventName extends StringKeyOf<TEventMap> = never>(
    eventName: TEventName,
  ): Observable<TEventMap[TEventName]>;
}
